import { Ref, watch } from '@nuxtjs/composition-api'

const EXTERNAL_PROVIDER_METHOD_PATTERN = /^externalIdps:(?:esia|vtb)/
const ALLOWED_REDIRECT_PROTOCOLS = ['http:', 'https:']

type BlitzAuthMessage = {
  event?: string
  methodName?: string
  type?: string
  url?: string
}

const getOrigin = (url: string): string | null => {
  try {
    return new URL(url, window.location.href).origin
  } catch (e) {
    return null
  }
}

const isSafeRedirectUrl = (url: string): boolean => {
  try {
    return ALLOWED_REDIRECT_PROTOCOLS.includes(
      new URL(url, window.location.href).protocol
    )
  } catch (e) {
    return false
  }
}

const appendQueryParameter = (url: string, name: string, value: string) =>
  `${url}${url.includes('?') ? '&' : '?'}${name}=${value}`

export const useBlitzPostMessage = (frameSrc: Ref<string | null>) => {
  watch(
    frameSrc,
    (src, _prev, onInvalidate) => {
      if (!src) {
        return
      }
      const frameOrigin = getOrigin(src)
      if (!frameOrigin) {
        return
      }
      const handleMessage = (event: MessageEvent<BlitzAuthMessage | null>) => {
        const data = event.data
        if (!data || typeof data !== 'object') {
          return
        }
        if (data.type === 'auth-redirect' && data.url) {
          if (
            event.origin === window.location.origin &&
            isSafeRedirectUrl(data.url)
          ) {
            window.location.assign(data.url)
          }
          return
        }
        if (event.origin !== frameOrigin) {
          return
        }
        if (
          data.event === 'clickMethod' &&
          typeof data.methodName === 'string' &&
          EXTERNAL_PROVIDER_METHOD_PATTERN.test(data.methodName)
        ) {
          const providerId = data.methodName.replace(
            'externalIdps',
            'used_externalIdps'
          )
          window.open(
            appendQueryParameter(src, 'bip_action_hint', providerId),
            '_self'
          )
        }
      }
      window.addEventListener('message', handleMessage)
      onInvalidate(() => {
        window.removeEventListener('message', handleMessage)
      })
    },
    { immediate: true }
  )
}
